import axios from "utils/axios";

export const getTemplatesImport = () => {
  return axios.get("/hr/templates/import/list");
};
